/**
 * StrengthPills Component
 * Horizontal scrollable pills showing top 3-5 recurring strengths
 */

import { CheckCircle2 } from 'lucide-react';
import { cn } from '@/lib/utils';

interface StrengthPill {
  strength_key: string;
  occurrences: number;
}

interface StrengthPillsProps {
  strengths: StrengthPill[];
  className?: string;
}

const strengthLabels: Record<string, string> = {
  stable_posture: 'Stable Posture',
  good_rotation: 'Good Rotation',
  consistent_balance: 'Consistent Balance',
  repeatable_tempo: 'Repeatable Tempo',
  clean_swing: 'Clean Swing'
};

export function StrengthPills({
  strengths,
  className
}: StrengthPillsProps) {
  if (strengths.length === 0) {
    return (
      <div className={cn("text-center py-8 text-muted-foreground", className)}>
        <p>No strengths identified in this snapshot.</p>
      </div>
    );
  }

  return (
    <div className={cn("space-y-3", className)}>
      <h3 className="text-lg font-semibold text-foreground">Strengths</h3>
      <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide">
        {strengths.map((strength, index) => (
          <div
            key={index}
            className={cn(
              "flex items-center gap-2 px-4 py-2 rounded-full",
              "bg-success/20 text-success border border-success/30",
              "whitespace-nowrap flex-shrink-0"
            )}
          >
            <CheckCircle2 className="w-4 h-4" />
            <span className="font-medium">
              {strengthLabels[strength.strength_key] || strength.strength_key.replace(/_/g, ' ')}
            </span>
            <span className="text-xs opacity-75">
              ({strength.occurrences}/5)
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}


